export default __webpack_public_path__ + "static/media/card_bg.6eac744e.jpg";